import React, { useState } from 'react';
import type { Contact, SentChannel } from '../../types';
import { markLeadSent, markLeadStatus } from '../../services/outbound';

interface PipelineActionsProps {
  contact: Contact;
  onChanged: () => void;
}

const PipelineActions: React.FC<PipelineActionsProps> = ({ contact, onChanged }) => {
  const [askingSent, setAskingSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const run = async (fn: () => Promise<boolean>) => {
    setBusy(true);
    await fn();
    setBusy(false);
    onChanged();
  };

  return (
    <div className="flex flex-wrap items-center justify-end gap-1" onClick={(e) => e.stopPropagation()}>
      <button
        disabled={busy}
        onClick={() => run(() => markLeadStatus(contact.id, 'approved'))}
        className="px-2 py-1 text-xs bg-orange-600/80 hover:bg-orange-500 text-white rounded"
      >
        Approved
      </button>
      <button
        disabled={busy}
        onClick={() => setAskingSent((open) => !open)}
        className="px-2 py-1 text-xs bg-blue-600/80 hover:bg-blue-500 text-white rounded"
      >
        Sent
      </button>
      <button
        disabled={busy}
        onClick={() => run(() => markLeadStatus(contact.id, 'replied', { replied_on: new Date().toISOString() }))}
        className="px-2 py-1 text-xs bg-cyan-700 hover:bg-cyan-600 text-white rounded"
      >
        Replied
      </button>
      <button
        disabled={busy}
        onClick={() => run(() => markLeadStatus(contact.id, 'no'))}
        className="px-2 py-1 text-xs bg-slate-700 hover:bg-slate-600 text-slate-200 rounded"
      >
        No
      </button>
      <button
        disabled={busy}
        onClick={() => run(() => markLeadStatus(contact.id, 'on_hold'))}
        className="px-2 py-1 text-xs bg-slate-700 hover:bg-slate-600 text-slate-200 rounded"
      >
        Hold
      </button>
      {askingSent && (
        <div className="flex gap-1 w-full justify-end mt-1">
          {(['email', 'linkedin', 'both'] as SentChannel[]).map((channel) => (
            <button
              key={channel}
              disabled={busy}
              onClick={() => {
                setAskingSent(false);
                run(() => markLeadSent(contact.id, channel));
              }}
              className="px-2 py-1 text-xs bg-slate-800 hover:bg-slate-700 text-white rounded capitalize"
            >
              {channel}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PipelineActions;
